<template>
  <div v-if="ordersStore.createOrderResponse != null">
    <div></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { createOrderRequest } from '../../api/models';
import * as Storage from '@/core/storage.js';
import Constants from '@/core/constants';

export default {
  name: 'Create',

  data() {
    return {};
  },

  computed: {
    ...mapState({ ordersStore: state => state.orders }),
  },

  mounted() {
    this.initCreateOrder();
  },

  watch: {
    '$store.state.orders.createOrderResponse'() {
      const res = this.ordersStore.createOrderResponse;
      if (!res) return;

      // --- Guardar dato fiscal si existe
      if (res.last_dato_solicitante_id) {
        Storage.setItem(
            Constants.KEY_LAST_FISCAL_CONTACT,
            String(res.last_dato_solicitante_id)
        );
      }

      // --- Validación de URL de pago
      if (!res.payment_url || !res.order_id) {
        console.error('Respuesta de pago incompleta:', res);
        this.$router.push({ name: 'orders', params: { action: 'error' } });
        return;
      }

      const redirectUrl = this.getPaymentResponseUrl(res.order_id);

      const paymentUrl = `${res.payment_url}`;

      window.location.replace(paymentUrl);
    },
  },

  methods: {
    ...mapActions('orders', ['createOrder']),

    // -------------------------
    //  Parser blindado
    // -------------------------
    safeParse(value) {
      try {
        if (typeof value === 'string') return JSON.parse(value);
        return value;
      } catch (e) {
        return null;
      }
    },

    initCreateOrder() {
      let request = createOrderRequest();

      const finalCart = this.safeParse(Storage.getItem('finalCart'));
      const finalCartInvoice = this.safeParse(Storage.getItem('finalCartInvoice'));

      if (!finalCart) {
        this.$router.push({ name: 'portfolio', params: { step: 1 } });
        return;
      }

      request.cart = finalCart;
      request.data_invoice = finalCartInvoice ?? {};
      request.url_return = this.getPaymentResponseUrl();

      // VueX
      this.createOrder(request);

      this.removeCartSession();
    },

    getPaymentResponseUrl(orderId = 'order_id') {
      const route = {
        name: 'orders_details',
        params: { action: 'payment_response', id: orderId },
      };

      return window.location.origin + this.$router.resolve(route).href;
    },

    removeCartSession() {
      Storage.removeItem('finalCart');
      Storage.removeItem('finalCartInvoice');
      Storage.removeItem('cart1');
      Storage.removeItem('cart2');
      Storage.removeItem('cart3');
    },
  },
};
</script>

<style scoped></style>